
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <h2 class="title">添加成功</h2>
      <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>
      <p class="tip-text">是否需要配置WI-FI网络？</p>
      <div class="btn-box">
          <button class="btn no f-l" @click="cancel()">不需要</button>
          <button class="btn yes f-r" @click="success()">需要</button>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import Common from '../../assets/js/common.js'
var _local = window.location.href
export default {
  name: 'TtipSelectBox',
  data () {
    return {
      imgSrc: Common.staticHref() + 'img/ScanSuccess.jpg',
      fromPage: this.$route.query.pageName
    }
  },
  methods: {
    cancel () {
      if (this.fromPage === 'Main') {
        sessionStorage.removeItem('isfirst')
        window.location.replace(_local.split('?')[0])
      } else {
        this.$router.push({path: '/'})
      }
    },
    success () {
      this.$router.push({path: '/ConfigWiFi'})
      // this.configWifi(this)
    },
    configWifi (_this) {
      wx.invoke('configWXDeviceWiFi', {}, function (res) {
        console.log(res)
        var errMsg = res.err_msg
        if (errMsg === 'configWXDeviceWiFi:ok') {
          // 配置成功
          // alert('WIFI配置成功')
          // 配网成功之后的回调地址
          _this.$router.push({path: '/wifiSuccess', query: {pageName: _this.fromPage}})
        } else if (errMsg === 'configWXDeviceWiFi:fail') {}
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    padding 21px 0
    border-radius 10px
    colmCenter()
    .title
      font-size 16px
      line-height 35px
      color #333333
    .tip-text
      font-size 15px
      color #333333
      line-height 44px
    .pic
      width 166px
      height 135px
      margin 0 auto
      background-repeat no-repeat
      background-position center center
      background-size contain
    .btn-box
      margin 0 auto
      width 284px
      height 40px
      .btn
        width 135px
        height 40px
        text-align center
        background #ededed
        color #ffffff
        font-size 17px
        border-radius 20px
      .no
        color #666666
      .yes
        color #0f95e1

</style>


// WEBPACK FOOTER //
// src/pages/ScanSuccess/ScanSuccess.vue